/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const REGISTER_WALLET = gql`
mutation RegisterMyWallet($signature: String, $expectedAddress: String, $message: String) {
  registerMyWallet(signature: $signature, expected_address: $expectedAddress, message: $message) {
    user {
      email
      givenName
      familyName
      fullName
      emailVerified
      isRegistered
      isInviEmailSent
      role {
        name
        _id
        permissions {
          subject
          action
          inverted
          fields
        }
      }
      brand {
        _id
        name
        email
      }
    }
  }
}
`
